const striptags = (text) => {
    return text.replace(/(<([^>]+)>)/ig, '');
}

const scrollToElem = (idEl) => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    let standardScrollValue = document.getElementById(idEl).getBoundingClientRect().top - document.body.getBoundingClientRect().top;

    let delta = scrollTop === 0 ? -150 : -68;
    const targetTop = standardScrollValue + delta;
    window.scrollTo({
        top: targetTop, behavior: 'smooth'
    });
}

const translationPhrase = (phrase) => {
    return window.transPhrase[phrase] ?? phrase;
}

const makeSlug = (text) => {
    return striptags(text).replace(/[:"|{}~!@#$%^&*()+]/ig, '').replace(/[\s]/ig, '-').toLowerCase();
}

const builCustomPostURL = (post) => {
    switch (post.type) {
        case 'edu_center':

            const catId1 = post.edu_category[0] ?? null;
            const catObj1 = post._embedded['wp:term'].filter(x => {
                return x[0] && x[0].id === catId1;
            });
            if (catObj1 && catObj1[0] && catObj1[0][0]) {
                return '/education-center/' + catObj1[0][0].slug + '/' + post.slug;
            }
            break;
        case 'post':

            const catId = post.categories[0] ?? null;
            const catObj = post._embedded['wp:term'].filter(x => {
                return x[0] && x[0].id === catId;
            });
            if (catObj && catObj[0] && catObj[0][0]) {
                return '/education-center/news/' + catObj[0][0].slug + '/' + post.slug;
            }
            break;
    }

    return post.link;
}

const truncate = (text, maxLength = 150) => {

    if (text.length < maxLength) {
        return text;
    }

    text = text.substring(0, maxLength);
    text = text.substring(0, Math.max(text.lastIndexOf(' '), text.lastIndexOf('.'), text.lastIndexOf(',')));
    return text + ' ...';
}

const formatNumber = (value, thousandSeparator = ' ') => {
    return ([...('' + value)].reverse().join('').match(/.{1,3}/g)).map((x) => [...x].reverse().join('')).reverse().join(thousandSeparator);
}

const acfDateFormatter = (text) => {
    if (text && text.length < 8) {
        return text;
    }

    return text.substring(6, 8) + '.' + text.substring(4, 6) + '.' + text.substring(0, 4)
}

const convertHTMLEntity = (text) => {
    const span = document.createElement('span');
    return text
        .replace(/&[#A-Za-z0-9]+;/gi, (entity, position, text) => {
            span.innerHTML = entity;
            return span.innerText;
        });
}

const updateLinks = (elWrap) => {
    const baseUrl = window.location.protocol + '//' + window.location.host;
    if (!elWrap.querySelector('a')) {
        return false;
    }

    elWrap.querySelectorAll('a').forEach(link => {

        if (link.hasAttribute('href') && link.getAttribute('href').length > 1) {
            if (link.getAttribute('href').substring(0, 1) === '#') {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    scrollToElem(link.getAttribute('href').substring(1));
                })
            } else {
                if (link.getAttribute('href').indexOf('://') > -1 && link.getAttribute('href').substring(0, baseUrl.length) !== baseUrl) {
                    link.setAttribute('target', '_blank');
                }
            }
        }

        if (link.parentNode && link.parentNode.tagName !== 'LI') {
            const linkWrapper = link.closest('li');
            if (linkWrapper) {
                linkWrapper.dataset.wrapLink = link.getAttribute('href');
                linkWrapper.classList.add('clickable');
                linkWrapper.addEventListener('click', e => window.location.href = e.currentTarget.dataset.wrapLink);
            }
        }
    });
}

export {
    truncate,
    convertHTMLEntity,
    builCustomPostURL,
    scrollToElem,
    makeSlug,
    striptags,
    formatNumber,
    acfDateFormatter,
    translationPhrase,
    updateLinks
}
